import { render, staticRenderFns } from "./cardCompany.vue?vue&type=template&id=e2269596&scoped=true&"
import script from "./cardCompany.vue?vue&type=script&lang=js&"
export * from "./cardCompany.vue?vue&type=script&lang=js&"
import style0 from "./cardCompany.vue?vue&type=style&index=0&id=e2269596&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2269596",
  null
  
)

export default component.exports